export default "__VITE_ASSET__DXOhi1WU__"